import React from 'react';
import { useNavigate } from 'react-router-dom';

const BackButton = ({ to, className = '', children = 'Back', withIcon = true, ...restProps }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    }
  };

  return (
    <button onClick={handleClick} className={`back-btn ${className}`} {...restProps}>
      {withIcon && <i className="fas fa-angle-double-left me-2" />}
      {children}
    </button>
  );
};

export default BackButton;


